export default __webpack_public_path__ + "static/media/pictogramFlight64.6ecaf0e9.svg";